import { isGradePassed, trim, yearsFromNow, daysFromYearsAgo, filterZeroArrays, getCoursesFromColleges, empty, totalCourseCredits, getTotalLoggedHours, handleize, coursesWithCreditsTotal } from '@/lib/utils'
import { calculateTotalCreditPoints, totalCASPAGPA, totalGPA, calculateCoursesCreditsTotal  } from '@/store/modules/mygrades'
export default {
  methods: {
    
    
   
    getGPAForCourses (minGPA, filter = (c) => c) {
      const {  totalCredits, qualityPoints } = calculateTotalCreditPoints(this.allowedUserColleges, true, filter)
      const targetGPA = this.savedSchool.caspa_participant ? totalCASPAGPA(qualityPoints, totalCredits) : totalGPA(qualityPoints, totalCredits)
      return targetGPA >= minGPA
    },
    getGPACheckCondition (minimumTotal = 0, required = 0, filter = (c) => c) {
      const minGPA = (empty(required)) ? 0 : parseFloat(required)
      const courses = coursesWithCreditsTotal(getCoursesFromColleges(this.allowedUserColleges), Number(minimumTotal), filter)
      const {  totalCredits, qualityPoints } = calculateCoursesCreditsTotal(courses, false)
      const targetGPA = this.savedSchool.caspa_participant ? totalCASPAGPA(qualityPoints, totalCredits) : totalGPA(qualityPoints, totalCredits)
      return targetGPA >= minGPA
    },
  },
  computed: {

    hasCompletedAllGpaRequirements() {
      if(this.hasCompletedGPARequirement && this.gpaConditionsClear) return true
    },
    hasCompletedGPARequirement () {
      if(this.completedOverallGPA && this.completedScienceGPA && this.completedPrerequisiteGPA ) return true
    },
  
    gpaConditionsClear () {
      return (
        this.getGPACheckCondition(30, this.savedSchool.last_30credits_science_gpa_minimum, this.filterScienceCourse) &&
        this.getGPACheckCondition(40, this.savedSchool.last_40credits_science_gpa_minimum, this.filterScienceCourse) &&
        this.getGPACheckCondition(45, this.savedSchool.last_45credits_gpa_minimum) &&
        this.getGPACheckCondition(60, this.savedSchool.last_60credits_gpa_minimum) &&
        (filterZeroArrays(this.savedSchool.gpa30_better_courses).length == 0 || this.getGPAForCourses(3, this.generateCoursesFilter(filterZeroArrays(this.savedSchool.gpa30_better_courses))))
      )
    },
   
    completedOverallGPA () {
      if(this.savedSchool.caspa_participant && this.overallCaspaGpa >= this.savedSchool.gpa_overall_minimum ) return true
      if(this.savedSchool.caspa_participant === false && this.overallGpa >= this.savedSchool.gpa_overall_minimum ) return true
    },
    completedScienceGPA () {
      if(this.savedSchool.caspa_participant && this.scienceCaspaGpa >= this.savedSchool.gpa_science_minimum) return true
      if(this.savedSchool.caspa_participant === false && this.scienceGpa >= this.savedSchool.gpa_science_minimum) return true
    },
    completedPrerequisiteGPA () {
      if(this.savedSchool.caspa_participant && this.scienceCaspaGpa >= this.savedSchool.gpa_prerequisite_minimum) return true
      if(this.savedSchool.caspa_participant === false && this.preReqGPA >= this.savedSchool.gpa_prerequisite_minimum) return true
    },
    preReqGPA () {
      const userColleges = [...this.userColleges]
      const {  totalCredits, qualityPoints } = calculateTotalCreditPoints(userColleges, true, (c) => this.isPreRequCourse(c))
      return totalGPA(qualityPoints, totalCredits)
    },
    preReqCASPAGPA () {
      const userColleges = [...this.userColleges]
      const {  totalCredits, qualityPoints } = calculateTotalCreditPoints(userColleges, false, (c) => this.isPreRequCourse(c))
      return totalCASPAGPA(qualityPoints, totalCredits)
    },

  }
}


// WEBPACK FOOTER //
// ./src/mixins/requirementchecks/checkgpamixin.js